import {
  APPOINTMENT_API,
  APPOINTMENT_API_GET_HOUR_LIST,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  CreatedAppointmentModel,
  GetHourListRequestModel,
  HourItemModel,
} from "./appointment.models";

export const getHourList = (requestModel: GetHourListRequestModel) => {
  return apiClient.postHttp<HourItemModel[]>(
    APPOINTMENT_API_GET_HOUR_LIST,
    requestModel,
    undefined,
    false
  );
};

export const createAppointment = (requestModel: CreatedAppointmentModel) => {
  return apiClient.postHttp(APPOINTMENT_API, requestModel, undefined, false);
};
